import 'css-chunk:src/components/ItemCard.module.scss';export default {
  "card": "_card_1rpkn_1"
};